import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const Page = styled.div`
  background-color: ${ColorV2.Blue7};
  min-height: 100vh;
  width: 100%;
  padding-top: 100px;
  padding-bottom: 20px;
  display: flow-root;
`;

export const LoaderWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
`;

export const ContentWrap = styled.div`
  position: relative;
`;

export const DimmedContent = styled.div<{ $dimmed: boolean }>`
  opacity: ${(props) => (props.$dimmed ? 0.6 : 1)};
  transition: opacity 120ms ease;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 3px solid ${ColorV2.Blue6};
  border-top-color: ${ColorV2.Blue1};
  animation: scheduleSpin 0.8s linear infinite;

  @keyframes scheduleSpin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  ${TypographyV2.b1};
  width: 100%;
  text-align: center;
  color: ${ColorV2.Blue4};
  padding: 32px 0;
`;

export const LoadMoreSentinel = styled.div`
  width: 100%;
  height: 1px;
`;
